import { autoinject } from 'aurelia-framework';
import { ValidateEvent, IValidatable } from '../elements/ess-rule';


interface IRules {
    [key: string]: IValidatable;
}

@autoinject()
export class EssValidateCustomAttribute {

    protected inputElement: HTMLElement | null = null;
    protected validationDictionary: IRules = {};

    protected handleValidate = ({ detail }: ValidateEvent) => {
        //using a dictionary to ensure we don't keep re-adding the same validators
        this.validationDictionary[detail.id] = detail;
        this.validate();
    }


    constructor(protected readonly element: Element) { }

    protected attached() {
        this.inputElement = this.element.querySelector('.ess-input-element');
        this.element.addEventListener('validate', this.handleValidate as EventListener);
    }

    protected detached() {
        this.element.removeEventListener('validate', this.handleValidate as EventListener);
    }

    protected validate() {
        let isValid = true;

        for(const key in this.validationDictionary) {
            if(this.validationDictionary[key].valid === false) {
                isValid = false;
            }
        }

        if(!isValid) {
            this.element.classList.add('ess-invalid');
            this.inputElement?.setAttribute('aria-invalid', 'true');
        } else {
            this.element.classList.remove('ess-invalid');
            this.inputElement?.setAttribute('aria-invalid', 'false');
        }
    }
}
